export enum WalletPaymentSteps {
    PaymentStart = 'request',
    ProvidePaymentDetails = 'details',
    ConfirmPaymentDetails = 'confirmation',
}
